import axios from "axios";

const getNewsletterSettings = async token => {
  try {
    const response = await axios.get(`${window.API}/newsletter-settings`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return { result: response.data };
  } catch (error) {
    return { error };
  }
};

export { getNewsletterSettings };
